/**
 * Functionality for Donate Home Page
 */
var Donate = {
    initialised: false
};

/**
 * Add event listeners
 */
Donate.init = function() {
    if (this.initialised) {
        return;
    }


    $(document).on('change', '#frequency-select', function(e) {

        var checkedSelector = $(e.currentTarget).find("input[name='frequency']:checked").val();

        if (checkedSelector === 'm') { // Monthly

            $('.amount-selection#one-time').addClass('d-none')
            $('.amount-selection#monthly').removeClass('d-none')
            $('.amount-selection#one-time').find('input[type="radio"]').prop('checked', false);

        } else if (checkedSelector === 'o') { // One-time

            $('.amount-selection#monthly').addClass('d-none');
            $('.amount-selection#one-time').removeClass('d-none');
            $('.amount-selection#monthly').find('input[type="radio"]').prop('checked', false);
        }

    });

    $(document).on('focus', '#donationAmount', function(e) {
        this.DeselectSetAmounts();
    }.bind(this));

    $(document).on('change', '.amount-selection', function(e) {
        this.ClearCustomAmount();
    }.bind(this));

    this.initialised = true;
};

Donate.DeselectSetAmounts = function() {
    console.log('DeselectSetAmounts');
    $('.amount-selection').find('input[type="radio"]').prop('checked', false);
};

Donate.ClearCustomAmount = function() {
    console.log('ClearCustomAmount');
    $('#mainDonationForm').find('#donationAmount').val('');
};

export default Donate;